<template lang="pug">
.label(v-if="label") {{ label }}
FormField(v-slot="$field" :name="name")
  Select(
    v-model="$field.value"
    :options="options"
    :optionLabel="$attrs.optionLabel || 'name'"
    :optionValue="$attrs.optionValue || 'code'"
    :placeholder="placeholder"
    :filter="$attrs.filter"
    :fluid="fluid"
    :showClear="$attrs.showClear==false ? undefined : true"
    @change="emit('change', $event)"
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
  
  //- pre $field: {{ $field }}
  //- pre options: {{ options }}
</template>

<script setup>
import { inject, ref } from 'vue'
import InputNumber from "primevue/inputnumber"
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';
import Select from "primevue/select"

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:         { type: String, required: true },
  options:      { type: Array, required: true, default: [] },
  label:        { type: String, required: false },
  placeholder:  { type: String, required: false },
  fluid:        { type: Boolean, required: false, default: true },
})

const emit = defineEmits(['change'])

defineOptions({ inheritAttrs: false })
</script>